<template>
  <div class="bg-gray-800 text-gray-300 shadow-2xl text-sm h-[65px] flex">
    <div class="w-full ml-2 md:ml-40 text-md">
      <div
        v-if="userStore.activeTab == '/explorer/dashboard'"
        class="max-h-[60px] overflow-hidden cursor-pointer px-2"
        @click="handleChangelogClick"
      >
        <div class="w-full break-words">
          <b class="block">Newest App Upgrades:</b>
        </div>
        <div class="line-clamp-2 break-words">
          <span v-html="newUpdates"></span>
        </div>
      </div>
    </div>
    <div v-if="isAble" class="mt-4 flex justify-center">
      <el-button
        :type="userStore.showExtended ? 'warning' : 'success'"
        @click="handleExtendedToggle"
      >
        <span v-if="userStore.showExtended"> Hide Extended </span>
        <span v-else> Show Extended </span>
      </el-button>
    </div>
    <div class="hidden flex justify-end">
      <div
        class="flex justify-end h-full"
        v-on-click-outside="checkClick"
        @click="checkClick"
      >
        <div class="pr-2 flex justify-evenly w-44 h-[65px] items-center">
          <div
            class="p-2 cursor-pointer rounded-full hover:bg-gray-700"
            ref="profileIcon"
          >
            <img
              src="@/assets/user.png"
              alt="profile picture"
              class="h-[24px] rounded-full bg-white"
            />
          </div>
          <div
            class="hidden p-2 rounded-full hover:bg-gray-700 relative"
            ref="notificationsIcon"
          >
            <Icon icon="ic:baseline-notifications" height="24" color="white" />
          </div>
          <div class="hidden p-2 rounded-full hover:bg-gray-700" ref="plusIcon">
            <Icon icon="iconamoon:sign-plus" height="24" color="white" />
          </div>
        </div>
        <div
          class="absolute top-[65px] bg-yellow-500 w-auto h-auto"
          v-if="menu"
        >
          <li
            v-for="item in menu"
            :key="item.id"
            class="list-none w-44 p-2 bg-black text-center hover:bg-blue-700"
          >
            {{ item.value }}
          </li>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { Icon } from "@iconify/vue";
import { ref, computed } from "vue";
import { vOnClickOutside } from "@vueuse/components";
import { useChangelog } from "@/composables/useChangelog";
import { useUser } from "@/stores";
const userStore = useUser();

const profileIcon = ref();
const notificationsIcon = ref();
const plusIcon = ref();
const menu = ref();
//const user = JSON.parse(localStorage.dumpStoreData).user;

const { recentUpdates } = useChangelog();
const newUpdates = computed(() => recentUpdates.value);

const isAble = userStore.user.email == import.meta.env.VITE_APP_EXTENDABLE_USER;

const handleChangelogClick = () => {
  // Force a small delay to ensure Vue's reactivity has time to process
  setTimeout(() => {
    userStore.activeTab = "/explorer/changelog";
  }, 0);
};

const handleExtendedToggle = () => {
  userStore.showExtended = !userStore.showExtended;
};

const compareMenus = (menuA, menuB) => {
  return JSON.stringify(menuA) == JSON.stringify(menuB);
};

const checkClick = (evt) => {
  if (profileIcon.value.contains(evt.target)) {
    menu.value = compareMenus(menu.value, profileMenu) ? null : profileMenu;
    return;
  }
  if (notificationsIcon.value.contains(evt.target)) {
    menu.value = compareMenus(menu.value, notificationsMenu)
      ? null
      : notificationsMenu;
    return;
  }
  if (plusIcon.value.contains(evt.target)) {
    menu.value = compareMenus(menu.value, plusMenu) ? null : plusMenu;
    return;
  }
  menu.value = null;
};
const profileMenu = [
  {
    id: 0,
    value: `Logged in as ${userStore.user.email}`,
  },
];

const notificationsMenu = [
  {
    id: 0,
    value: "4 new reviews this week!",
  },
  {
    id: 1,
    value: "Verify your email!",
  },
  {
    id: 2,
    value: "john@aopartners.com left a review today",
  },
];

const plusMenu = [
  {
    id: 0,
    value: "Add a reviewer",
  },
  {
    id: 1,
    value: "Add a user",
  },
  {
    id: 2,
    value: "Add a business",
  },
];
</script>
<style scoped></style>
